import React from 'react';
import { Container } from '../style';
import Lola from "./../lola.png"
import Head from "./../head.jpg"
import { useTranslation } from "react-i18next";


const Structure = () => {
    const { t } = useTranslation();
    return (
      
        <Container>
        <br />
        <br />
        <section className="department">
          <header className="department__header">
            <h2 className="department__title">{t("chairman.title")}</h2>
          </header>
          <div className="department__content">
            <div className="department__info">
              <p className="department__description">{t("chairman.description")}</p>
              <div className="functions">
                <h3 className="functions__title">{t("chairman.functionsTitle")}</h3>
                <ul className="functions__list">
                  {t("chairman.functions", { returnObjects: true }).map((func, index) => (
                    <li key={index} className="functions__item">{func}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="employees">
              <div className="employee">
                <div className="employee__photo-wrapper">
                  <div className="employee__photo-placeholder">
                    <img src={Head} alt={t("chairman.employee.name")} />
                  </div>
                </div>
                <div className="employee__info">
                  <h3 className="employee__name">{t("chairman.employee.name")}</h3>
                  <div className="employee__contacts">
                    <span className="employee__contact">
                      <span className="employee__contact-icon">📧</span>
                      {t("chairman.employee.email")}
                    </span>
                    <span className="employee__contact">
                      <span className="employee__contact-icon">📱</span>
                      {t("chairman.employee.phone")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  
        <section className="department">
          <header className="department__header">
            <h2 className="department__title">{t("deputyChairman.title")}</h2>
          </header>
          <div className="department__content">
            <div className="department__info">
              <p className="department__description">{t("deputyChairman.description")}</p>
              <div className="functions">
                <h3 className="functions__title">{t("deputyChairman.functionsTitle")}</h3>
                <ul className="functions__list">
                  {t("deputyChairman.functions", { returnObjects: true }).map((func, index) => (
                    <li key={index} className="functions__item">{func}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="employees">
              <div className="employee">
                <div className="employee__photo-wrapper">
                  <div className="employee__photo-placeholder">
                    <img src={Lola} alt={t("deputyChairman.employee.name")} />
                  </div>
                </div>
                <div className="employee__info">
                  <h3 className="employee__name">{t("deputyChairman.employee.name")}</h3>
                  <div className="employee__contacts">
                    <span className="employee__contact">
                      <span className="employee__contact-icon">📧</span>
                      {t("deputyChairman.employee.email")}
                    </span>
                    <span className="employee__contact">
                      <span className="employee__contact-icon">📱</span>
                      {t("deputyChairman.employee.phone")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Container>
    );
}

export default Structure;
